module.exports = "<p>\n  greek works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/meme/src/app/greek/greek.component.html
// module id = ../../../../../src/app/greek/greek.component.html
// module chunks = main